import { ArrowLeft, ArrowRight, Home } from "lucide-react";

import { PaneMenu } from "./PaneMenu";
import { canGoBack, canGoForward, usePaneManager } from "./store";

function NavIcon({
    icon,
    title,
    disabled,
    onClick,
}: {
    icon: React.ReactNode;
    title: string;
    disabled?: boolean;
    onClick: () => void;
}) {
    return (
        <button
            type="button"
            className="flex size-7 shrink-0 items-center justify-center rounded bg-transparent text-text-muted transition-colors hover:bg-text-primary/5 hover:text-interactive disabled:cursor-default disabled:text-text-muted/30 disabled:hover:bg-transparent"
            onClick={onClick}
            disabled={disabled}
            title={title}
        >
            {icon}
        </button>
    );
}

/**
 * どの画面にも出るヘッダー（[[2026-08-18 設計ノート アドイン 画面ナビゲーションと履歴]]）。
 * 左から題名（メニューの引き金）・戻る・進む・余白・ホームの4つで、どの画面でも意味が変わらない
 * ものだけを置く。題名の幅を固定してあるので、名前が何であっても戻る・進むは同じ場所に居る。
 *
 * ツールチップは正式名称と「戻る」「進む」だけにする。行き先を出すと、履歴が動くたびに文言が
 * 変わって読む負担になるため。
 */
export function PaneHeader({ title }: { title: string }) {
    const goBack = usePaneManager((s) => s.goBack);
    const goForward = usePaneManager((s) => s.goForward);
    const goToHome = usePaneManager((s) => s.goToHome);
    const backable = usePaneManager(canGoBack);
    const forwardable = usePaneManager(canGoForward);
    return (
        <header className="z-2 flex shrink-0 items-center gap-1 bg-sidebar-bg px-4 py-2.5 elev-pane-head">
            <PaneMenu title={title} />
            <NavIcon
                icon={<ArrowLeft size={16} />}
                title="戻る"
                disabled={!backable}
                onClick={goBack}
            />
            <NavIcon
                icon={<ArrowRight size={16} />}
                title="進む"
                disabled={!forwardable}
                onClick={goForward}
            />
            <div className="min-w-0 flex-1" />
            <NavIcon icon={<Home size={16} />} title="ホーム" onClick={goToHome} />
        </header>
    );
}
